import React, { Component } from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";

export default class PresentationModal extends Component {
    render() {
        let media;
        const url = this.props.presentation.visualUrl || '';

        if (url.match(/swf/)) {
            media = <object data={url} />;
        } else if (url.match(/pdf/)) {
            media = <div className="modal-pdf-container"><embed src={url} width="100%" height="100%" type="application/pdf" /></div>;
        } else if (url.match(/mp4/)) {
            media = <video src={url} controls autoPlay preload="metadata" />;
        }
        return (
            <Modal className="presentation-modal" show={this.props.showModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.area.name || this.props.area}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {media}
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/PresentationModal.jsx.erb